import { DataTransferMethod } from "../../Enums/DataTransferMethod";
import { Module } from "./Module";

export class S7Module extends Module{
    ipAddress!: []
    dataTransferMethod !: DataTransferMethod 
    transputs!: string[]
}
